import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DTOBase, PatchDocument } from '../models/dto.model';
import { HttpClient } from '@angular/common/http';
import { Paged } from '../models/pagination.model';

export const toPatchDoc = <T extends DTOBase>(
  object: T,
  updatableProperties: string[]
): PatchDocument[] => {
  let doc: PatchDocument[] = [];

  if (updatableProperties) {
    for (const [key, value] of Object.entries(object)) {
      if (updatableProperties.includes(key)) {
        doc.push({
          op: 'replace',
          path: `/${key}`,
          value: value,
        });
      }
    }
  }

  return doc;
};

export const getSingleModel = <T extends DTOBase>(
  client: HttpClient,
  path: string,
  id: string
): Observable<T> => {
  const url = `${environment.API}/api/${path}/${id}`;
  return client.get<T>(url);
};

export const getAllModels = <T extends DTOBase>(
  client: HttpClient,
  path: string
): Observable<T[]> => {
  const url = `${environment.API}/api/${path}`;
  return client.get<T[]>(url);
};

export const getPaged = <T extends DTOBase>(
  client: HttpClient,
  path: string,
  pageNumber: number = 1,
  pageSize: number = 10,
  queryParameters: string
): Observable<Paged<T>> => {
  const url = `${environment.API}/api/${path}?pageNumber=${pageNumber}&pageSize=${pageSize}${queryParameters}`;
  return client
    .get<T[]>(url, {
      observe: 'response',
    })
    .pipe(
      map((response) => {
        const paginationJSON = response.headers.get('X-Pagination');
        const paginationData: Paged<T> = JSON.parse(paginationJSON ?? '{}');

        paginationData.data = response.body;
        return paginationData;
      })
    );
};

export const createMdoel = <T extends DTOBase>(
  client: HttpClient,
  path: string,
  body: T
): Observable<T> => {
  const url = `${environment.API}/api/${path}`;
  return client.post<T>(url, body);
};

export const updateModel = <T extends DTOBase>(
  client: HttpClient,
  path: string,
  updatableProperties: string[],
  body: T
): Observable<T> => {
  const url = `${environment.API}/api/${path}/${body.id}`;
  const patchDoc = toPatchDoc(body, updatableProperties);

  return client.patch<T>(url, patchDoc);
};

export const deleteModel = (
  client: HttpClient,
  path: string,
  id: string
): Observable<boolean> => {
  const url = `${environment.API}/api/${path}/${id}`;
  return client.delete<boolean>(url);
};
